import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { MCTranslationStateService } from '@maslul/common-services';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient
    , private translationStateService: MCTranslationStateService
  ) { }

  getTranslation(lang: string): Observable<any> {
    return this.http.get('/API/MITranslate/localization').pipe(
      map((allTranslations: any) => {
        this.translationStateService.setTranslationsLoaded(true);
        return allTranslations[lang] || {}
      })
    );
  }
}